import { useContext } from 'react';

import { UrlSearchStateContext, type UrlSearchStateContextValue } from '../providers/UrlSearchStateProvider';

export const useUrlSearchState = (): UrlSearchStateContextValue => {
  const ctx = useContext(UrlSearchStateContext);

  // oxlint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (ctx === undefined) {
    throw new Error('useUrlSearchState used outside of UrlSearchStateProvider!');
  }

  return ctx;
};
